const thirdConfig = {
  wechat: {
    url: 'https://open.weixin.qq.com/connect/qrconnect',
    appid: 'wxd54d990607580ebf',
    redirect_uri: 'https://img.zai-art.com/auth.html',
    response_type: 'code',
    scope: 'snsapi_login',
    state: '4'
  },
  weibo: {
    url: 'https://api.weibo.com/oauth2/authorize',
    client_id: '1086831308',
    redirect_uri: 'https://img.zai-art.com/auth.html',
    response_type: 'code',
    scope: 'all',
    state: '5'
  },
  qq: {
    url: 'https://graph.qq.com/oauth2.0/authorize',
    client_id: '101343480',
    redirect_uri: 'https://img.zai-art.com/auth.html',
    response_type: 'code',
    scope: 'get_user_info',
    state: '3'
  },
  mpWechat: {
    url: 'https://open.weixin.qq.com/connect/oauth2/authorize',
    appid: 'wxdfe9887d4d8bcba6',
    redirect_uri: 'https://img.zai-art.com/auth.html',
    response_type: 'code',
    scope: 'snsapi_userinfo',
    state: '4'
  }
}
export default thirdConfig
